import CancelIcon from "@mui/icons-material/Cancel";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { Box, Button, Typography, useTheme } from "@mui/material";
import React from "react";
import { Link, useRouteError } from "react-router-dom";

export default function ErrorPage() {
  const theme = useTheme(); // <-- získáme aktivní téma
  const error = useRouteError();
  const status = error?.status || error?.response?.status;

  const Wrapper = ({ children }) => (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        bgcolor: theme.palette.background.default, // světlo / tma
        color: theme.palette.text.primary, // světlo / tma
        p: 2,
      }}
    >
      <Box sx={{ textAlign: "center", maxWidth: 800 }}>{children}</Box>
    </Box>
  );

  /* ---------- 401 ---------- */
  if (status === 401) {
    return (
      <Wrapper>
        <CancelIcon sx={{ fontSize: 80, color: "error.main", mb: 2 }} />
        <Typography variant="h3" gutterBottom>
          Neautorizovaný přístup
        </Typography>
        <Typography sx={{ my: 2 }}>
          Z důvodu nečinnosti jste byl automaticky odhlášen. Přihlaste se prosím znovu.
        </Typography>
        <Button component={Link} to="/login" variant="contained">
          Na přihlašovací stránku
        </Button>
      </Wrapper>
    );
  }

  /* ---------- 403 ---------- */
  if (status === 403) {
    return (
      <Wrapper>
        <CancelIcon sx={{ fontSize: 80, color: "error.main", mb: 2 }} />
        <Typography variant="h3" gutterBottom>
          Přístup zakázán
        </Typography>
        <Typography sx={{ my: 2 }}>
          Nemáte dostatečná oprávnění k zobrazení této stránky.
        </Typography>
        <Button component={Link} to="/" variant="contained">
          Zpět na domovskou stránku
        </Button>
      </Wrapper>
    );
  }

  /* ---------- Ostatní chyby ---------- */
  return (
    <Wrapper>
      <ErrorOutlineIcon sx={{ fontSize: 80, color: "error.main", mb: 2 }} />
      <Typography variant="h3" gutterBottom>
        Oops!
      </Typography>
      <Typography variant="h6">
        Omlouváme se, došlo k neočekávané chybě.
      </Typography>
      <Typography sx={{ my: 2 }}>
        <i>{error.statusText || error.message}</i>
      </Typography>
      <Button component={Link} to="/" variant="contained">
        Zpět na domovskou stránku
      </Button>
    </Wrapper>
  );
}
